import React, { useState } from 'react';
import { TextEditor } from '../Editor';
import { useFormContext } from '@/providers';

const RulesSelection = () => {
    const { watch, setValue, errors, fieldRefs } = useFormContext();
    const [selectedRules, setSelectedRules] = useState([]);

    const handleRuleSelect = (e) => {
        const newRule = e.target.value;
        if (newRule && !selectedRules.includes(newRule)) {
            const updatedRules = [...selectedRules, newRule];
            setSelectedRules(updatedRules);
            setValue('rules', updatedRules.join('\n\n')); // Join with double newlines
            e.target.value = ''; // Reset select
        }
    };

    const handleRemoveRule = (index) => {
        const updatedRules = selectedRules.filter((_, i) => i !== index);
        setSelectedRules(updatedRules);
        setValue('rules', updatedRules.join('\n\n'));
    };

    const handleTextEditorChange = (content) => {
        setValue('rules', content);
        // Update selectedRules if needed
        setSelectedRules(content.split('\n\n').filter(rule => rule.trim() !== ''));
    };



    return (
        <>
            <div className="mt-2 text-left md:col-span-12">
                <label>
                    Rules
                    <i className="fal fa-clock" />
                </label>
                <select
                    name="rules"
                    placeholder="Rules"
                    ref={(el) => (fieldRefs.current['rules'] = el)}
                    onChange={handleRuleSelect}
                    className="flex items-center w-full gap-4 px-3 py-3 border rounded-md border-input"
                >
                    <option disabled value="">
                        Choose as many rules as you would like. Feel free to edit
                        or add your own.
                    </option>
                    <option value="Quiet Hours: Quiet hours are from [specific time] to [specific time]. Please respect the neighbors.">
                        Quiet Hours: Quiet hours are from [specific time] to
                        [specific time]. Please respect the neighbors.
                    </option>
                    <option value="Respect the Neighborhood: Please be mindful of noise and parking, and respect the property and surrounding community.">
                        Respect the Neighborhood: Please be mindful of noise and
                        parking, and respect the property and surrounding
                        community.
                    </option>

                    <option value="Report Any Damages: Please report any accidental damages immediately. Any unreported damages may result in fees.">
                        Report Any Damages: Please report any accidental damages
                        immediately. Any unreported damages may result in fees.
                    </option>
                    <option value="No Unregistered Guests: Only registered guests listed in the booking are allowed to stay at the property. No additional overnight guests.">
                        No Unregistered Guests: Only registered guests listed in
                        the booking are allowed to stay at the property. No
                        additional overnight guests.
                    </option>
                    <option value="Use of Amenities: Please use all amenities (pool, hot tub, etc.) responsibly. Follow safety rules, and use at your own risk.">
                        Use of Amenities: Please use all amenities (pool, hot tub,
                        etc.) responsibly. Follow safety rules, and use at your
                        own risk.
                    </option>
                    <option value="Cleaning: Please tidy up before checkout. Washing dishes and taking out the trash would be appreciated.">
                        Cleaning: Please tidy up before checkout. Washing dishes
                        and taking out the trash would be appreciated.
                    </option>
                    <option value="Key/Entry Instructions: Guests are responsible for keeping the keys and access codes safe. A fee may apply for lost keys or access codes.">
                        Key/Entry Instructions: Guests are responsible for keeping
                        the keys and access codes safe. A fee may apply for lost
                        keys or access codes.
                    </option>
                    <option value="Trash and Recycling: Guests are required to follow the trash and recycling procedures. Please dispose of garbage properly.">
                        Trash and Recycling: Guests are required to follow the
                        trash and recycling procedures. Please dispose of garbage
                        properly.
                    </option>
                    <option value="Energy Conservation: Please turn off lights, AC/heating, and appliances when not in use.">
                        Energy Conservation: Please turn off lights, AC/heating,
                        and appliances when not in use.
                    </option>
                    <option value="Parking: Parking is limited to [insert number] spaces. Guests are responsible for following the parking rules.">
                        Parking: Parking is limited to [insert number] spaces.
                        Guests are responsible for following the parking rules.
                    </option>
                    <option value="Children: Children are welcome, but supervision is required, especially around [mention any safety concerns like pools or balconies].">
                        Children: Children are welcome, but supervision is
                        required, especially around [mention any safety concerns
                        like pools or balconies].
                    </option>
                    <option value="Security Cameras: For your safety and security, there are [exterior] cameras monitoring the property.">
                        Security Cameras: For your safety and security, there are
                        [exterior] cameras monitoring the property.
                    </option>
                    <option value="House Access: Guests should only access the areas of the home specified in the listing. Certain parts of the property may be off-limits.">
                        House Access: Guests should only access the areas of the
                        home specified in the listing. Certain parts of the
                        property may be off-limits.
                    </option>
                    <option value="Local Laws: Please adhere to all local laws and regulations during your stay.">
                        Local Laws: Please adhere to all local laws and
                        regulations during your stay.
                    </option>
                </select>
                {errors?.rules && (
                    <p style={{ color: "red" }}>
                        {errors?.rules?.message}
                    </p>
                )}

                {/* Display selected rules with remove buttons */}

            </div>

            <div className="mt-2 text-left md:col-span-12">
                <label>Edit Rules</label>
            </div>
            <div className="mt-2 text-left md:col-span-12">
                <TextEditor
                    field={'rules'}
                    value={watch('rules') || ''}
                    onChange={handleTextEditorChange}
                />
            </div>
            <div className="mt-5 text-left md:col-span-12">
                {errors?.rules && (
                    <p style={{ color: "red" }}>
                        {errors?.rules?.message}
                    </p>
                )}
            </div>
        </>
    );
};

export default RulesSelection;